import { render, staticRenderFns } from "./DigitalKeyWidget.vue?vue&type=template&id=43810ddf&scoped=true"
import script from "./DigitalKeyWidget.vue?vue&type=script&lang=js"
export * from "./DigitalKeyWidget.vue?vue&type=script&lang=js"
import style0 from "./DigitalKeyWidget.vue?vue&type=style&index=0&id=43810ddf&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43810ddf",
  null
  
)

export default component.exports